/*!
 * @Author: leo
 * @Date: 2021-07-09 16:52:00
 * @Last Modified by: leo
 * @Last Modified time: 2021-07-09 16:52:00
 * @Instruduction: 安全服务接口
 */

import xhr from './xhr/index'
import { BaseParams, DetailParams } from './index'

interface IViolatingListParams extends BaseParams {}

interface IGetComplaintsParams extends BaseParams {}

interface IUpdateComplaintParams {
    id: number
    status: number
}

interface IGetComplaintParams extends DetailParams {}

interface IUpdateViolatingInfoParams extends DetailParams {}

interface IGetViolatingInfoParams extends DetailParams {}

class SecurityService {
    /** 获取违规内容列表 */
    public async getViolatingList(params: IViolatingListParams) {
        const result = await xhr({
            method: 'get',
            url: '/violating_content/list',
            params: params
        })
        return result
    }
    /** 更新投诉内容 */
    public async updateViolatingInfo(params: IUpdateViolatingInfoParams) {
        const result = await xhr({
            method: 'put',
            url: '/violating_content',
            params: params
        })
        return result
    }
    /** 更新投诉内容 */
    public async getViolatingInfo(params: IGetViolatingInfoParams) {
        const result = await xhr({
            method: 'get',
            url: '/violating_content',
            params: params
        })
        return result
    }
    /** 获取投诉内容列表 */
    public async getComplaints(params: IGetComplaintsParams) {
        const result = await xhr({
            method: 'get',
            url: '/content_complaint/list',
            params: params
        })
        return result
    }
    /** 更新投诉内容 */
    public async updateComplaint(params: IUpdateComplaintParams) {
        const result = await xhr({
            method: 'put',
            url: '/content_complaint',
            params: params
        })
        return result
    }
    /** 投诉内容 */
    public async getComplaint(params: IGetComplaintParams) {
        const result = await xhr({
            method: 'get',
            url: '/content_complaint',
            params: params
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new SecurityService()
